import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IOrganization } from 'src/app/models/interfaces/organization.interface';
import { ParametersValuesFormContext } from '../parameters/parameters-values-form/parameters-values-form-context';

export class OrganizationDetailContext extends DefaultDetailContext<IOrganization, string> {
    public paramsContext: ParametersValuesFormContext = new ParametersValuesFormContext();
}
